import * as ActionTypes from "../ActionTypes";

const initialState = {
    mpr_requests_data: [],
    isLoadingMprRequests: false,
    approver_mpr_requests: [],
    isLoadingApproverMprRequests: false,
    mpr_dashboard: [],
    isLoadingMprDashboard: false,
    mpr_dashboard_cards: [],
    isLoadingMprDashboardCards: false,
};

export const MprRequestReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.ATS_MPR_REQUESTS_GET_REQUEST:
            return {
                ...state,
                isLoadingMprRequests: true,
                mpr_requests_data: []
            };
        case ActionTypes.ATS_MPR_REQUESTS_GET_SUCCESS:
            return {
                ...state,
                isLoadingMprRequests: false,
                mpr_requests_data: action.payload?.data?.data,
            };
        case ActionTypes.ATS_MPR_REQUESTS_GET_ERROR:
            return {
                ...state,
                isLoadingMprRequests: false,
            };
        case ActionTypes.ATS_MPR_REQUESTS_UPSERT_REQUEST:
            return {
                ...state,
                isLoadingMprRequests: true,
            };
        case ActionTypes.ATS_MPR_REQUESTS_UPSERT_SUCCESS:
            return {
                ...state,
                isLoadingMprRequests: false,
                mpr_requests_data: action.payload?.data?.data,
            };
        case ActionTypes.ATS_MPR_REQUESTS_UPSERT_ERROR:
            return {
                ...state,
                isLoadingMprRequests: false,
            };
        case ActionTypes.ATS_APPROVER_MPR_REQUESTS_GET_REQUEST:
            return {
                ...state,
                isLoadingApproverMprRequests: true,
                approver_mpr_requests: []
            };
        case ActionTypes.ATS_APPROVER_MPR_REQUESTS_GET_SUCCESS:
            return {
                ...state,
                isLoadingApproverMprRequests: false,
                approver_mpr_requests: action.payload?.data?.data,
            };
        case ActionTypes.ATS_APPROVER_MPR_REQUESTS_GET_ERROR:
            return {
                ...state,
                isLoadingApproverMprRequests: false,
            };
        case ActionTypes.ATS_APPROVER_MPR_REQUESTS_UPDATE_REQUEST:
            return {
                ...state,
                isLoadingApproverMprRequests: true,
            };
        case ActionTypes.ATS_APPROVER_MPR_REQUESTS_UPDATE_SUCCESS:
        case ActionTypes.ATS_APPROVER_MPR_REQUESTS_UPDATE_ERROR:
            return {
                ...state,
                isLoadingApproverMprRequests: false,
            };
        case ActionTypes.ATS_MPR_DASHBOARD_GET_REQUEST:
            return {
                ...state,
                isLoadingMprDashboard: true,
                mpr_dashboard: []
            };
        case ActionTypes.ATS_MPR_DASHBOARD_GET_SUCCESS:
            return {
                ...state,
                isLoadingMprDashboard: false,
                mpr_dashboard: action.payload?.data?.data,
            };
        case ActionTypes.ATS_MPR_DASHBOARD_GET_ERROR:
            return {
                ...state,
                isLoadingMprDashboard: false,
            };
        case ActionTypes.ATS_MPR_DASHBOARD_CARDS_GET_REQUEST:
            return {
                ...state,
                isLoadingMprDashboardCards: true,
                mpr_dashboard_cards: {}
            };
        case ActionTypes.ATS_MPR_DASHBOARD_CARDS_GET_SUCCESS:
            return {
                ...state,
                isLoadingMprDashboardCards: false,
                mpr_dashboard_cards: action.payload?.data?.data,
            };
        case ActionTypes.ATS_MPR_DASHBOARD_CARDS_GET_ERROR:
            return {
                ...state,
                isLoadingMprDashboardCards: false,
            };
        default:
            return state;
    }
};

export default MprRequestReducer;
